export default "__VITE_ASSET__0219770b__"